import React, { useEffect, useState } from 'react'
import { supabase } from '../../../supabaseClient'

export default function AnalyticsSummary({ branchId, onViewFull }) {
    const [stats, setStats] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const today = new Date()
                today.setHours(0, 0, 0, 0)
                const monthISO = new Date(today.getFullYear(), today.getMonth(), 1).toISOString()

                let todayQuery = supabase
                    .from('orders')
                    .select('final_amount, order_status')
                    .gte('created_at', today.toISOString())

                if (branchId) todayQuery = todayQuery.eq('branch_id', branchId)
                const { data: todayOrders } = await todayQuery

                let monthQuery = supabase
                    .from('orders')
                    .select('final_amount')
                    .eq('order_status', 'completed')
                    .gte('created_at', monthISO)

                if (branchId) monthQuery = monthQuery.eq('branch_id', branchId)
                const { data: monthOrders } = await monthQuery

                const completed = (todayOrders || []).filter(o => o.order_status === 'completed')
                const todayRevenue = completed.reduce((s, o) => s + (parseFloat(o.final_amount) || 0), 0)
                const monthRevenue = (monthOrders || []).reduce((s, o) => s + (parseFloat(o.final_amount) || 0), 0)

                setStats({
                    todayRevenue,
                    todayOrders: (todayOrders || []).length,
                    monthRevenue,
                })
            } catch (err) {
                console.error('AnalyticsSummary fetch error:', err)
            } finally {
                setLoading(false)
            }
        }
        fetchStats()
    }, [branchId])

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" className="text-green-600">
                            <path fill="currentColor" d="M4.329 9.433a.4.4 0 0 1 .4.4v4.668a.4.4 0 0 1-.4.4H1.53a.4.4 0 0 1-.402-.4V9.833c0-.22.18-.4.402-.4zM1.933 14.1h1.994v-3.868H1.933zm7.495-13a.4.4 0 0 1 .401.4v13c0 .22-.18.4-.4.4H6.63a.4.4 0 0 1-.402-.4v-13c0-.22.18-.4.402-.4zm-2.395 13h1.993V1.9H7.033zm7.495-9.437a.4.4 0 0 1 .4.4V14.5a.4.4 0 0 1-.4.4H11.73a.4.4 0 0 1-.402-.4V5.063c0-.22.18-.4.402-.4zm-2.396 9.438h1.994V5.464h-1.994z"/>
                        </svg>
                    </div>
                    <h3 className="font-semibold text-gray-800 text-sm">AI Analytics</h3>
                </div>
                <button
                    onClick={onViewFull}
                    className="text-xs text-[#A0826D] hover:text-[#8B5A3C] font-medium flex items-center gap-1 transition-colors">
                    View Full
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                </button>
            </div>

            <div className="p-5">
                {loading ? (
                    <div className="flex gap-3">
                        {[1,2,3].map(i => <div key={i} className="flex-1 h-16 bg-gray-100 rounded-lg animate-pulse"/>)}
                    </div>
                ) : (
                    <div className="grid grid-cols-3 gap-3">
                        <div className="bg-green-50 rounded-lg p-3">
                            <p className="text-xs text-green-600 font-medium mb-1">Today's Revenue</p>
                            <p className="text-lg font-bold text-green-700">
                                ₱{(stats?.todayRevenue ?? 0).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </p>
                        </div>
                        <div className="bg-blue-50 rounded-lg p-3">
                            <p className="text-xs text-blue-600 font-medium mb-1">Today's Orders</p>
                            <p className="text-lg font-bold text-blue-700">{stats?.todayOrders ?? 0}</p>
                        </div>
                        <div className="bg-amber-50 rounded-lg p-3">
                            <p className="text-xs text-amber-600 font-medium mb-1">Month Revenue</p>
                            <p className="text-lg font-bold text-amber-700">
                                ₱{(stats?.monthRevenue ?? 0).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}